import React from 'react';

const Logo = () => {
  return (
    <div className='mka__logo-img'>
    <div className='mka__logo-size'>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
      viewBox='0 0 69.85 16.933'
    >
      <defs>
        <clipPath>
          <path d='M0 500h500V0H0z' transform='matrix(1 0 0 -1 0 500)'></path>
        </clipPath>
        <clipPath>
          <path d='M0 500h500V0H0z' transform='matrix(1 0 0 -1 0 500)'></path>
        </clipPath>
      </defs>
      <g>
        <path
          fill='red'
          d='M9.463 9.864L8.35 16.173H7.148l.273-1.55c.17-.766.33-1.532.5-2.298l-.04-.018-.837 1.658-.454.856H5.379l-.152-.856-.253-1.658-.046.018c-.11.766-.21 1.532-.319 2.298l-.273 1.55H3.142l1.112-6.309h1.237l.531 2.389c.065.315.176.865.204 1.099h.035c.11-.234.415-.784.592-1.1l1.372-2.388z'
          style={{ strokeWidth: '0.145311' }}
          display='inline'
        ></path>
        <path
          fill='red'
          d='M11.358 13.785l-.438.568-.32 1.82H9.387L10.5 9.864h1.212l-.426 2.415.435-.703 1.15-1.712h1.402l-2.027 2.758 1.174 3.551h-1.384z'
          style={{ strokeWidth: '0.145311' }}
          display='inline'
        ></path>
        <path
          d='M18.014 13.91l-.01-.72c0-.45.032-1.217.062-1.73h-.035c-.15.513-.381 1.28-.547 1.73l-.266.72zm.028 1.218h-1.28l-.384 1.045h-1.271l2.565-6.309h1.315l.342 6.309h-1.272z'
          style={{ strokeWidth: '0.145311' }}
          fill='#fff'
          display='inline'
        ></path>
        <path
          d='M20.11 14.145l.755-4.28h1.28l-.755 4.28c-.102.577.06.892.492.892s.704-.315.806-.892l.755-4.28h1.28l-.755 4.28c-.235 1.334-1.094 2.136-2.306 2.136-1.21 0-1.788-.802-1.552-2.136'
          style={{ strokeWidth: '0.145311' }}
          fill='#fff'
          display='inline'
        ></path>
        <path
          d='M28.67 11.08h-1.185l-.898 5.093h-1.263l.897-5.092h-1.185l.215-1.217h3.634z'
          style={{ strokeWidth: '0.145311' }}
          fill='#fff'
          display='inline'
        ></path>
        <path
          d='M31.247 14.127l.391-2.217c.105-.595-.073-.91-.531-.91-.46 0-.748.315-.853.91l-.391 2.217c-.105.595.073.91.532.91.458 0 .747-.315.852-.91m-2.656 0l.391-2.217c.238-1.352 1.115-2.154 2.344-2.154 1.228 0 1.822.802 1.584 2.154l-.39 2.217c-.24 1.352-1.116 2.154-2.345 2.154-1.228 0-1.822-.802-1.584-2.154'
          style={{ strokeWidth: '0.145311' }}
          fill='#fff'
          display='inline'
        ></path>
        <path
          d='M39.344 9.864l-1.112 6.309h-1.203l.273-1.55c.17-.766.331-1.532.5-2.298l-.04-.018-.837 1.658-.454.856h-1.21l-.153-.856-.252-1.658-.047.018c-.11.766-.21 1.532-.319 2.298l-.273 1.55h-1.194l1.112-6.309h1.238l.53 2.389c.066.315.176.865.205 1.099h.034c.11-.234.415-.784.592-1.1l1.373-2.388z'
          style={{ strokeWidth: '0.145311' }}
          fill='#fff'
          display='inline'
        ></path>
        <path
          d='M42.113 14.127l.391-2.217c.105-.595-.073-.91-.531-.91-.459 0-.748.315-.853.91l-.39 2.217c-.106.595.072.91.53.91.46 0 .748-.315.853-.91m-2.656 0l.391-2.217c.239-1.352 1.115-2.154 2.344-2.154 1.228 0 1.822.802 1.584 2.154l-.39 2.217c-.24 1.352-1.116 2.154-2.345 2.154-1.228 0-1.822-.802-1.584-2.154'
          style={{ strokeWidth: '0.145311' }}
          fill='#fff'
          display='inline'
        ></path>
        <path
          d='M46.654 14.28c.081-.46-.129-.694-.587-.694h-.493l-.243 1.38h.467c.484 0 .776-.235.856-.686m-.637-3.208l-.232 1.316h.485c.346 0 .569-.235.647-.676.074-.424-.06-.64-.458-.64zm1.899 3.217c-.199 1.127-1.077 1.884-2.115 1.884H43.89l1.113-6.309h1.886c.934 0 1.473.721 1.284 1.794-.084.477-.364.982-.738 1.289.403.27.582.775.482 1.342'
          style={{ strokeWidth: '0.145311' }}
          fill='#fff'
          display='inline'
        ></path>
        <path
          d='M50.616 9.864l-1.112 6.309h-1.229l1.113-6.309z'
          style={{ strokeWidth: '0.145311' }}
          fill='#fff'
          display='inline'
        ></path>
        <path
          d='M53.785 14.956l-.215 1.217h-3.028l1.112-6.309h1.229l-.898 5.092z'
          style={{ strokeWidth: '0.145311' }}
          fill='#fff'
          display='inline'
        ></path>
        <path
          d='M57.548 14.956l-.215 1.217h-3.21l1.113-6.309h3.123l-.214 1.217H56.25l-.23 1.307h1.721l-.206 1.171h-1.722l-.246 1.397z'
          style={{ strokeWidth: '0.145311' }}
          fill='#fff'
          display='inline'
        ></path>
        <path
          d='M57.376 1.223l-17.826.473-4.818.05a89.045 89.045 0 00-3.06-.62L29.765.12z'
          style={{ strokeWidth: '0.145311' }}
          fill='#fff'
          display='inline'
        ></path>
        <path
          d='M65.977 4.885l-10.685.283-8.21.086c-.216-.287-.58-.563-.98-.801a.033.033 0 01-.016-.009 20.522 20.522 0 00-.615-.216l-.013-.009a21.447 21.447 0 00-1.125-.35l5.42.213z'
          style={{ strokeWidth: '0.145311' }}
          fill='#fff'
          display='inline'
        ></path>
        <path
          d='M23.782 6.966s-.564.121-1.048.26c.198-.239.913-1.087 1.184-1.157.317-.084 2.14.001 2.14.001s-1.875-.336-2.288-.087c-.412.246-1.281 1.311-1.281 1.311h.017l-.112.038s.692-1.157 1.322-1.499c.631-.343 2.897.084 3.168.47.268.388-1.293.965-3.102.663'
          style={{ strokeWidth: '0.145311' }}
          fill='#fff'
          display='inline'
        ></path>
        <path
          fill='red'
          d='M65.276 11.59l-5.585.06-.406.002c.043-.084.091-.185.144-.29l.406.014z'
          style={{ strokeWidth: '0.145311' }}
          display='inline'
        ></path>
        <path
          style={{ strokeWidth: '0.145311' }}
          fill='#fff'
          d='M60.474 9.04a.298.298 0 00-.06-.293c-.191-.253-.717-.45-1.139-.571a3.202 3.202 0 00-.552-.207 3.462 3.462 0 00-.625-.12h-.008a3.569 3.569 0 00-.304-.02l-.475-.011-.067-.001-13.654-.28c.374-.05.722-.125 1.053-.214h.005a6.99 6.99 0 00.948-.325c.435-.184.75-.582.845-1.046l.004-.008c.032-.165-.455-.405-1.21-.674-1.646-.578-4.545-1.284-5.857-1.595l-.557-.13c.144.027.397.073.726.137h.009c1.591.306 4.914.95 5.791 1.209.443.129.8.244 1.066.37.45.206.645.442.572.805.229-.285.284-.56.117-.786l-.02-.026c-.216-.286-.58-.563-.98-.801a.033.033 0 01-.016-.009 20.536 20.536 0 00-.615-.216l-.013-.009a21.445 21.445 0 00-1.125-.35 24.67 24.67 0 00-2.14-.53c-2.831-.574-5.389-1.148-7.461-1.593a88.975 88.975 0 00-3.06-.62 15.03 15.03 0 00-1.598-.225c-1.222-.077-3.635.824-5.477 2.034-.88.576-3.116 2.356-3.373 2.843-.2.374.002.796.188 1.1.053.09.107.166.166.24.241.002.482.006.728.014l.503.007c.072 0 .148.006.22.007 1.097.02 2.18.044 3.221.063 5.667.123 10.225.243 10.225.243l-.34.423-23.466-.064c-3.858.102-5.824.215-6.613.36-2.709.5-3.787 1.631-6.056 3.373 0 0 1.607-4.3 7.79-4.525 2.474-.087 4.751-.052 10.287.04.453-.553.773-.756 1.416-1.322C20.651 4.717 26.37.399 29.481.02c.45-.053 1.215 0 2.204.137l.19.028c1.96.278 4.742.856 7.675 1.511 3.562.796 7.355 1.714 10.203 2.386 1.937.455 3.435.794 4.128.901.464.07.938.132 1.41.185 2.6.291 5.119.323 5.119.323l-1.362 2 .02.009c.01 0 .018.004.03.009a5.187 5.187 0 01.951.415c.353.204.696.48.81.82.012.022.02.043.024.064.016.068.028.136.031.208-.177.506-.5 1.195-.787 1.78.105-.545.198-1.098.24-1.436v-.047c.045-.109.084-.202.106-.273'
          display='inline'
        ></path>
        <path
          fill='red'
          d='M61.028 8.743a3.333 3.333 0 00-.114.273c-.177.506-.5 1.195-.787 1.78-.105.214-.205.412-.292.58-.052.1-.1.193-.144.273-.087.177-.148.286-.148.286l-.42.057s.065-.13.162-.34c.043-.084.091-.185.144-.29.292-.61.72-1.518.939-2.049.044-.109.083-.202.106-.273.004-.013.008-.026.009-.038 0-.08-.07-.162-.183-.253-.239-.19-.672-.395-1.025-.573a3.207 3.207 0 00-.552-.207l.065-.092.26-.386.02.009c.01 0 .018.004.03.009l.038.013c.042.017.097.04.164.061.085.036.19.075.304.12.164.06.345.144.525.227.37.174.728.366.879.457.138.086.099.18.02.356'
          style={{ strokeWidth: '0.145311' }}
          display='inline'
        ></path>
        <path
          fill='red'
          d='M69.85 8.48l-8.822.263-.728.006c-.239-.19-.672-.394-1.025-.573a3.207 3.207 0 00-.552-.207l.065-.092 1.341.053z'
          style={{ strokeWidth: '0.145311' }}
          display='inline'
        ></path>
      </g>
    </svg>
    </div>
        </div>
  );
};

export default Logo;
